import { render, staticRenderFns } from "./ReferenceFileDownloadItem.vue?vue&type=template&id=cb12bcac&scoped=true&"
import script from "./ReferenceFileDownloadItem.vue?vue&type=script&lang=js&"
export * from "./ReferenceFileDownloadItem.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceFileDownloadItem.vue?vue&type=style&index=0&id=cb12bcac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb12bcac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VChip,VHover,VIcon,VItem})
